import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Util from '../../util/AspectRatioCardUtil';
import './AspectRatioCardImage.less';

class AspectRatioCardImage extends PureComponent {
    static propTypes = {
        /** The card aspect ratio, which determines the maintained aspect ratio of the image block. This does NOT need to be specified if this component is used as a child of AspectRatioCard. */
        aspectRatio: PropTypes.oneOf([
            '16x9',
            '3x2',
            '4x3',
            '1x1',
            '3x4'
        ]),
        /** The URI of the image to be rendered. */
        imageUri: PropTypes.string,
        /** Callback to invoke when the image has been loaded. */
        onLoad: PropTypes.func
    };

    static defaultProps = {
        imageUri: '',
        onLoad: () => {}
    };

    static displayName = 'AspectRatioCardImage';

    state = {
        boundSide: 'width',
        aspectRatioData: Util.getAspectRatioData(this.props.aspectRatio),
        imageAspectRatioData: {ratio: 0}
    };

    // if image is server-side rendered, call image loaded callback when component mounts because image onload may never be dispatched
    componentDidMount() {
        if (this.image && this.image.complete) {
            this.handleImageOnLoad({target: this.image});
        }
    }

    handleImageOnLoad = (e) => {
        const {imageAspectRatioData, aspectRatioData, boundSide} = this.state;
        if (imageAspectRatioData && imageAspectRatioData.ratio === 0) {
            const img = e.target;
            const newImageAspectRatioData = Util.getAspectRatioData(`${img.naturalWidth}x${img.naturalHeight}`);
            const newBoundSide = Util.getImageBoundSide(newImageAspectRatioData.ratio, aspectRatioData.ratio);
            if (newImageAspectRatioData.ratio !== imageAspectRatioData.ratio || newBoundSide !== boundSide) {
                this.setState({
                    imageAspectRatioData: newImageAspectRatioData,
                    boundSide: newBoundSide
                });
            }
            this.props.onLoad(newImageAspectRatioData);
        }
    }

    /* istanbul ignore next */
    setImageRef = (element) => {
        this.image = element;
    }

    render() {
        const {
            imageUri
        } = this.props;

        const {boundSide, imageAspectRatioData} = this.state;
        const imageClasses = classnames('AspectRatioCardImage__image', {
            'AspectRatioCardImage__image--width-100': boundSide === 'width',
            'AspectRatioCardImage__image--height-100': boundSide === 'height',
            'AspectRatioCardImage__image--not-loaded': !imageAspectRatioData || !imageAspectRatioData.ratio
        });

        return (
            <div className="AspectRatioCardImage">
                <img
                    alt={''}
                    className={imageClasses}
                    src={imageUri}
                    onLoad={this.handleImageOnLoad}
                    ref={this.setImageRef}
                />
            </div>
        );
    }
}

export default AspectRatioCardImage;
